export default class Billing {
	/**
	 * Customer billing address
	 */
	address?: string = undefined;

	/**
	 * Customer billing country alpha-2 code (ISO 3166-1)
	 */
	country?: string = undefined;

	/**
	 * Customer billing state alpha code (ISO 3166-2)
	 */
	state?: string = undefined;

	/**
	 * Customer billing city
	 */
	city?: string = undefined;

	/**
	 * Customer billing postal code
	 */
	zip?: string = undefined;

	/**
	 * Customer billing phone
	 */
	phone?: string = undefined;
}
